import Qs from 'qs';
import lodash from 'lodash';
import http from 'libs/http';
import { api } from 'libs/config';
import axios from 'axios';
import {message} from 'antd';
import BytedUploader from './uploader/index';

//处理列表搜索条件
const formatFilter = (param_table, param_filter, pagination) => {
  const { pageSize, current } = pagination;
  let search = Qs.parse(window.location.search.slice(1));
  if (param_table) {
    search.pageSize = param_table.pageSize;
    search.pageNo = param_table.pageSize === pageSize ? param_table.current : 1;
  } else if (param_filter) {
    search = {
      ...param_filter,
      pageSize,
      pageNo: 1
    };
  } else {
    search.pageSize = pageSize;
    search.pageNo = current;
  }

  return search;
}

//cookie相关操作
const krCookie = {
  get: key => {
    let value = null;
    document.cookie.split('; ').forEach((item) => {
      const arr = item.split('=');
      if (arr[0] === key) {
        value = decodeURI(arr[1]);
      }
    });
    return value;
  },
  set: ({ key, value, expires, path }) => {
    document.cookie=`${key}=${value}; expires=${expires}; path=${path}`;
  },
  delete: key => {
    document.cookie=`${key}=; expires=Thu, 01 Jan 2000 00:00:00 GMT`;
  }
};

//文件大小, size单位是B
const krFileSize = (size) => {
  if (size < 1000) {
    return `${size}B`;
  } else if (size < 1000 ** 2) {
    return `${(size / 1000).toFixed(0)}KB`;
  } else if (size < 1000 ** 3) {
    return `${(size / 1000 ** 2).toFixed(1)}MB`;
  } else {
    return `${(size / 1000 ** 3).toFixed(2)}GB`;
  }
}

//获得字符串字符长度
const krStrLen = (str) => {
  str = str ? String(str) : '';
  let count = 0;
  for(let kr of str) {
    if (kr) {}; //完全就是为了避免‘未使用’警告
    count++;
  }
  return count;
}

/**
 * 获取字符串长度 新要求：
 *  一个汉字一个字符
 *  二个字符一个字符
 *  大写字母为1个汉字
 *  一个emoji两个字符
 **/
const newKrStrLen = (str, direction = 'up') => {
  if (str == null) return 0;
  if (typeof str != 'string') {
    str += '';
  }

  let len = 0;

  for (var j = 0; j < str.length; j++) {
    if (str.charCodeAt(j) > 127 || str.charCodeAt(j) === 94 || (str.charCodeAt(j) >= 65 && str.charCodeAt(j) <= 90)) {
      len += 1;
    } else {
      len += 0.5;
    }
  }
  return direction === 'up' ? Math.ceil(len) : Math.floor(len)
};

/**
 * 单个emoji表情占用2个字符长度，转换成1个
 * @param {string} str 含有emoji表情的字符串
 * @returns 返回字符串中emoji的个数
 */
function emojiSize(str) {
  let emoji_exp = /(\u00a9|\u00ae|[\u2000-\u3300]|\ud83c[\ud000-\udfff]|\ud83d[\ud000-\udfff]|\ud83e[\ud000-\udfff])/g;
  const ms = [...str.matchAll(emoji_exp)];
  // if (!ms || !ms.length) return str.length;
  return ms.length;
}

/**
 * 获取字符长度
 * 中文记1个字符，英文和符号记0.5个 大写字母和全角符号算2个字符
 * @param {*} str
 * @param {string} direction  向上取整up || 向下取整down
 */

const half = [32, 33, 34, 35, 36, 37, 38,
  39, 40, 41, 42, 43, 44, 45,
  46, 47, 58, 59, 60, 61, 62,
  63, 64, 91, 92, 93, 94, 95,
  96, 123, 124, 125, 126]

const whole = [
  8211, 8212, 8216, 8217, 8220, 8221,
  8230, 12289, 12290, 12296, 12297, 12298,
  12299, 12300, 12301, 12302, 12303, 12304,
  12305, 12308, 12309, 65281, 65288, 65289,
  65292, 65294, 65306, 65307, 65311
]

export const newkrStrLen = function(str, direction = 'up') {
  if (str == null) return 0;
  if (typeof str != 'string') {
    str += '';
  }

  let len = 0;

  for (var j = 0; j < str.length; j++) {
    if (str.charCodeAt(j) >= 97 && str.charCodeAt(j) <= 122) {
      len += 1;
    } else if (str.charCodeAt(j) >= 65 && str.charCodeAt(j) <= 90) {
      len += 2;
    } else if (str.charCodeAt(j) >= 19968 && str.charCodeAt(j) <= 40869) {
      len += 2;
    } else if (str.charCodeAt(j) >= 49 && str.charCodeAt(j) <= 57) {
      len += 1;
    } else if (half.includes(str.charCodeAt(j))) {
      len += 1;
    } else if (whole.includes(str.charCodeAt(j))) {
      len += 2;
    } else {
      len += 1;
    }
  }
  return len
  
};
/**
 * 获取字符长度
 * 中文记1个字符，英文和符号记0.5个
 * 最终结果
 * 1. 向上取整"up"，如“测试a”，最终返回长度为3；如“测试ab”，最终返回长度也为3
 * 2. 向下取整"down"，如“测试a”，最终返回长度为2；如“测试ab”，最终返回长度为3
 * @param {*} str
 * @param {string} direction  向上取整up || 向下取整down
 */

export const getStrLength = function(str, direction = 'up') {
  if (str == null) return 0;
  if (typeof str != 'string') {
    str += '';
  }

  let len = 0;

  for (var j = 0; j < str.length; j++) {
    if (str.charCodeAt(j) > 127 || str.charCodeAt(j) === 94) {
      len += 1;
    } else {
      len += 0.5;
    }
  }
  let emojiSum = emojiSize(str);
  if (direction === 'up') {
    return emojiSum > 0 ? Math.ceil(len) - emojiSum : Math.ceil(len);
  } else {
    return emojiSum > 0 ? Math.floor(len) - emojiSum : Math.floor(len);
  }
};

//获得字符串字节长度
const krStrBytes = (str) => {
  str = str ? String(str) : '';
  return str.replace(/[^\u0000-\u00ff]/g,'aa').length; //eslint-disable-line
}

//定长截取字符串
const krStrCrop = (str = '', n = 10) => {
  if (str.length > n) {
    return str.slice(0, n) + '...';
  }
  return str;
}

//浅拷贝对象并且去除字符串值的前后空格
const krStrTrim = values => {
  if (!values || typeof values !== 'object') return values;
  const data = {};
  for(let attr in values) {
    if(typeof values[attr] === 'string') {
      data[attr] = values[attr].trim();
    } else {
      data[attr] = values[attr];
    }
  }
  return data;
}

//去除对象中值不存在(undefined、null、'')的项目，同时具有krStrTrim功能
const cleanObject = values => {
  if (!values || typeof values !== 'object') return values;
  const data = {};
  for(let attr in values) {
    if(values[attr] && typeof values[attr] === 'string') {
      data[attr] = values[attr].trim();
    } else if (values[attr] || values[attr] === 0) {
      data[attr] = values[attr];
    }
  }
  return data;
}

//单张图片上传
const uploadImage = ({ accept, beforeUpload, success, error, hasMinWidthTwoHundred = false, qualityFlag = 0 }) => {
  const fileDom = document.createElement('input');
  fileDom.type = 'file';
  fileDom.accept = accept || "image/*,.jpg,.jpeg,.png,.gif";
  fileDom.style.display = 'none';
  document.body.appendChild(fileDom);
  fileDom.click();
  fileDom.onchange = (event) => {
    const file = event.target.files[0];
    document.body.removeChild(fileDom);
    const fileName = file.name;
    // const fileSize = Math.round(file.size / 1000);
    const formData = new FormData();
    formData.append('param.file', file, fileName);
    if(hasMinWidthTwoHundred) {
      formData.append('param.sizeFlag', 0);
    }
    // 是否开启压缩 1--开启，不填或其它--不开启,为了文章编辑富文本编辑上传图片时压缩用，为了不影响其它在使用该公共方法，所以只有传1时添加该传参
    if (qualityFlag) {
      formData.append('param.qualityFlag', qualityFlag);
    }
    beforeUpload && beforeUpload();
    http.upload('/tool/upload', formData)
      .then(res => {
        success && success(res);
      })
      .catch(() => {
        error && error();
      });
  };
}

//多张图片上传
const uploadImages = ({ accept, beforeUpload, success, error, qualityFlag = 0 }) => {
  const fileDom = document.createElement('input');
  const formData = new FormData();
  fileDom.type = 'file';
  fileDom.multiple = true;
  fileDom.accept = accept || "image/*,.jpg,.jpeg,.png,.gif";
  fileDom.style.display = 'none';
  document.body.appendChild(fileDom);
  fileDom.click();
  fileDom.onchange = (event) => {
    const files = event.target.files;
    Array(files.length).fill(1).forEach((_, i) => {
      const fileName = files[i].name;
      formData.append(`param.files[${i}]`, files[i], fileName);
    });
    // 是否开启压缩 1--开启，不填或其它--不开启,为了文章编辑富文本编辑上传图片时压缩用，为了不影响其它在使用该公共方法，所以只有传1时添加该传参
    if (qualityFlag) {
      formData.append('param.qualityFlag', qualityFlag);
    }
    document.body.removeChild(fileDom);
    beforeUpload && beforeUpload();
    http.upload('/tool/uploadBatch', formData)
    .then(res => {
      success && success(res.imageList || []);
    })
    .catch(() => error && error());
  };
}

/**
 * 阿里云批量上传文件
 * option.accept[string] 接受文件的格式，默认 'audio/mpeg'
 * option.type[string] 文件类型，可填[img,file,video,audio]，默认 'audio'
 * option.size[number] 限制文件大小，单位是byte
 * option.amount[number] 限制文件的总数量
 * option.selectedTotal[number] 已上传的文件数量
 * option.onBefore[fn()] 开始上传执行
 * option.onSuccess[fn(array)] 上传完成执行，自动传入上传文件列表信息
 * option.onError[fn(err)] 上传失败时执行，自动传入错误对象
 * */
const uploadFilesToOSS = ({
  accept = 'audio/mpeg',
  type = 'audio',
  size,
  amount,
  selectedTotal = 0,
  onBefore, onSuccess, onError }) => {
  const file = document.createElement('input');
  file.type = 'file';
  file.multiple = true;
  file.accept = accept;
  file.style.display = 'none';
  document.body.appendChild(file);
  file.click();
  file.onchange = (event) => {
    const selectedFiles = event.target.files;
    const fileErr = Array(selectedFiles.length).fill(1);
    document.body.removeChild(file);

    //判断文件大小是否合法
    if (size && fileErr.some((_, i) => selectedFiles[i].size > size)) {
      return onError && onError( new Error('存在大小超过限制的文件，请检查'));
    }

    //判断上传文件数量是否超过设定值
    if (amount && (selectedTotal + selectedFiles.length) > amount) {
      return message.error(`文件数量超过${amount}个`);
    }

    //上传开始前执行
    onBefore && onBefore();

    //请求认证
    http.json('/oss/signature', { fileType: type }, { baseURL: api.gassist })
    .then(res => {
      //循环调用上传
      Promise.all(fileErr.map((_, i) => new Promise((resolve, reject) => {
        const fileName = selectedFiles[i].name;
        const fileFormat = fileName.slice(fileName.lastIndexOf('.') + 1);
        const fileKey = `${res.dir}v2_${Date.now() + i}_${type}_${fileFormat}`;
        const formData = new FormData();
        formData.append('key', fileKey);
        formData.append('policy', res.policy);
        formData.append('OSSAccessKeyId', res.accessid);
        formData.append('success_action_status', '200');
        formData.append('signature', res.signature);
        formData.append('file', selectedFiles[i], fileName);
        axios.post('', formData, {
          withCredentials: false,
          headers:{'Content-Type':'multipart/form-data'},
          baseURL: res.host
        })
        .then(() => {
          let ossUrl = `https://audio.36krcdn.com/${fileKey}`;
          if (type === 'img') {
            ossUrl = `https://img.36krcdn.com/${fileKey}`;
          } else if (type === 'file') {
            ossUrl = `https://file.36krcdn.com/${fileKey}`;
          } else if (type === 'video') {
            ossUrl = `https://videos.36krcdn.com/${fileKey}`;
          }
          resolve({
            path: `/${fileKey}`,
            ossUrl,
            fileName
          });
        }).catch(err => reject(err));
      }))).then(res => {
        onSuccess && onSuccess(res);
      }).catch(err => onError && onError(err));
    }).catch(err => onError && onError(err));
  };
}

//从图片配置对象提取图片列表
const imageConfigToPaths = (imageConfig = {}) => {
  const sourceImageList = [imageConfig.sourceImageConfig];
  const photoConfigList = imageConfig.photoConfigList || [];
  const smallTemplateImageConfigList = imageConfig.smallTemplateImageConfigList || [];
  const bigTemplateImageConfigList = imageConfig.bigTemplateImageConfigList || [];
  const threeTemplateImageConfigList = imageConfig.threeTemplateImageConfigList || [];
  let templateImageList = [];
  const templateItemList = [
    ...smallTemplateImageConfigList,
    ...bigTemplateImageConfigList,
    ...threeTemplateImageConfigList
  ];
  templateItemList.forEach(itemList => {
    templateImageList = templateImageList.concat(itemList);
  });

  const imageList = [
    ...sourceImageList,
    ...photoConfigList,
    ...templateImageList
  ];
  return imageList.filter(v => lodash.get(v, 'image.path')).map(item => {
    return {
      imageKey: item.imageKey,
      imagePath: item.image.path,
      imageSource: item.image.imageSource || item.imageSource  || 1
    }
  });
}

// 获取浏览器内核信息
const getBrowserInfo = () => {
  let ua = navigator.userAgent.toLocaleLowerCase();
  let browserType = null;
  if (ua.match(/msie/) != null || ua.match(/trident/) != null) {
    browserType = "IE";
  } else if (ua.match(/firefox/) != null) {
    browserType = "火狐";
  } else if (ua.match(/ubrowser/) != null) {
    browserType = "UC";
  } else if (ua.match(/opera/) != null) {
    browserType = "欧朋";
  } else if (ua.match(/bidubrowser/) != null) {
    browserType = "百度";
  } else if (ua.match(/metasr/) != null) {
    browserType = "搜狗";
  } else if (ua.match(/tencenttraveler/) != null || ua.match(/qqbrowse/) != null) {
    browserType = "QQ";
  } else if (ua.match(/maxthon/) != null) {
    browserType = "遨游";
  } else if (ua.match(/edge/) != null) {
    browserType = "edge";
  } else if (ua.match(/chrome/) != null) {
    let is360 = _mime("type", "application/vnd.chromium.remoting-viewer");
    function _mime(option, value) {
      let mimeTypes = navigator.mimeTypes;
      for (let mt in mimeTypes) {
        if (mimeTypes[mt][option] == value) {
          return true;
        }
      }
      return false;
    }
    if (is360) {
      browserType = '360';
    } else {
      browserType = '谷歌'
    }
  } else if (ua.match(/safari/) != null) {
    browserType = "Safari";
  }
  return browserType;
}

const downloadImage = ({imgId, name}) => {
  const image = new Image();
  // 解决跨域 canvas 污染问题
  image.setAttribute("crossOrigin", "anonymous");
  image.onload = function() {
    const canvas = document.createElement("canvas");
    canvas.width = image.width;
    canvas.height = image.height;
    const context = canvas.getContext("2d");
    context.drawImage(image, 0, 0, image.width, image.height);
    //得到图片的base64编码数据
    const url = canvas.toDataURL("image/png");
    // 生成一个 a 标签
    const a = document.createElement("a");
    // 创建一个点击事件
    const event = new MouseEvent("click");
    // 将 a 的 download 属性设置为我们想要下载的图片的名称，若 name 不存在则使用'图片'作为默认名称
    a.download = name || "二维码";
    // 将生成的 URL 设置为 a.href 属性
    a.href = url;
    // 触发 a 的点击事件
    a.dispatchEvent(event);
    // return a;
  };
  image.src = document.getElementById(imgId).src;
}

const createBytedUploader = () => {
  return new BytedUploader({
    userId: '36kr-media', //建议设置能识别用户的唯一标识id，用于上传出错时排查问题，不要传入非 ASCII编码
    appId: 2098, //企业直播appid，写死2098即可
    //仅图片上传时需要配置
    imageConfig: {
        serviceId: 'gjr78lqtd0' // 企业直播serviceId，写死gjr78lqtd0即可
    },
    // 仅视频/普通文件上传时需要配置
    videoConfig: {
      spaceName: 'livesaas-new' //企业直播paceName，写死livesaas-new即可
    }
  });
}

function isArray(val) {
  var toString = {}.toString;

  return toString.call(val) === '[object Array]';
}

// 一维数组判断相等
function equalArray(arr1 ,arr2) {
  return arr1.sort().toString() == arr2.sort().toString()
}

function isObject(val) {
  return !isArray(val) && typeof val === 'object' && !!val;
}

/******** json2formdata 36kr版，非标准版 ******/
function mergeObjects(object1, object2) {
  var objectsToMerge = [object1, object2];

  return objectsToMerge.reduce(function(carry, objectToMerge) {
    Object.keys(objectToMerge).forEach(function(objectKey) {
      carry[objectKey] = objectToMerge[objectKey];
    });

    return carry;
  }, {});
}

/**
 * 
 * @param {*} jsonObject 
 * @param {*} options 
 * @param {*} parentKey 
 * @param {FormData} carryFormData 
 */
function convertRecursively(jsonObject, options, parentKey, carryFormData) {
  var formData = carryFormData || new FormData();
  var index = 0;
  for (var key in jsonObject) {
    if (jsonObject.hasOwnProperty(key)) {
      if (jsonObject[key] !== null && jsonObject[key] !== undefined) {
        var propName = parentKey || key;

        if (parentKey && isObject(jsonObject)) {
          // NOTE BLAME 强烈吐槽，这个不符合通用form表单格式
          propName = parentKey + '.' + key;
        }

        if (parentKey && isArray(jsonObject)) {
          if (
            isArray(jsonObject[key]) ||
            isObject(jsonObject[key]) ||
            options.showLeafArrayIndexes
          ) {
            propName = parentKey + '[' + index + ']';
          } else {
            propName = parentKey + '[]';
          }
        }

        if (jsonObject[key] instanceof File) {
          formData.append(propName, jsonObject[key], jsonObject[key].name || '');
        } else if (jsonObject[key] instanceof FileList) {
          for (var j = 0; j < jsonObject[key].length; j++) {
            formData.append(propName + '[' + j + ']', jsonObject[key].item(j),  jsonObject[key].item(j).name || '');
          }
        } else if (isArray(jsonObject[key]) || isObject(jsonObject[key])) {
          convertRecursively(jsonObject[key], options, propName, formData);
        } else if (typeof jsonObject[key] === 'boolean') {
          formData.append(propName, +jsonObject[key] ? '1' : '0');
        } else {
          formData.append(propName, jsonObject[key]);
        }
      }
    }

    index++;
  }

  return formData;
}

function json2formdata(jsonObject, options) {
  var defaultOptions = {
    showLeafArrayIndexes: true
  };

  var mergedOptions = mergeObjects(defaultOptions, options || {});

  return convertRecursively(jsonObject, mergedOptions);
}

// 获取任意一天的开始时间、结束时间的时间戳
function getDayTime({time='today', type}) {
  let d = '';
  if (time === 'today') {
    if (type === 'start') {
      d = new Date(new Date(new Date().toLocaleDateString()).getTime());
    } else {
      d = new Date(new Date(new Date().toLocaleDateString()).getTime() + 24 * 60 * 60 * 1000 - 1);
    }
  } else if (time === 'yestoday') {
    if (type === 'start') {
      d = new Date(new Date(new Date().toLocaleDateString()).getTime()- 24*60*60*1000);
    } else {
      d = new Date(new Date(new Date().toLocaleDateString()).getTime() - 1);
    }
  } else if (time === 'week') {
    if (type === 'start') {
      d = getFirstDayOfWeek(new Date(new Date().toLocaleDateString()));
    } else {
      d = new Date(new Date(new Date().toLocaleDateString()).getTime() + 24 * 60 * 60 * 1000 - 1);;
    }
  } else if (time === '7day') {
    if (type === 'start') {
      d = new Date(new Date(new Date().toLocaleDateString()).getTime()- 24*60*60*1000*7);
    } else {
      d = new Date(new Date(new Date().toLocaleDateString()).getTime());
    }
  }
  return d;
}

function getFirstDayOfWeek (date) {
  var day = date.getDay() || 7;
  return new Date(date.getFullYear(), date.getMonth(), date.getDate() + 1 - day);
};
function formatDateTime (date) {
  var y = date.getFullYear();
  var m = date.getMonth() + 1;//注意这个“+1”
  m = m < 10 ? ('0' + m) : m;
  var d = date.getDate();
  d = d < 10 ? ('0' + d) : d;
  var h = date.getHours();
  h=h < 10 ? ('0' + h) : h;
  var minute = date.getMinutes();
  minute = minute < 10 ? ('0' + minute) : minute;
  var second=date.getSeconds();
  second=second < 10 ? ('0' + second) : second;
  return y + '-' + m + '-' + d+' '+h+':'+minute+':'+second;
}
/**
 * 格式化时间戳
 * @param {Number} timestamp 
 * @param {String} timeformat YYYY 或 YY, MM 或 M, DD 或 D, hh 或 h(可选), mm 或 m(可选), ss 或 s(可选)组成的时间格式，
 *                            例如：'YYYY年MM月DD日 hh:mm:ss
 */
function format(timestamp, timeformat = 'YYYY-MM-DD hh:mm:ss') {
  const date = new Date(timestamp)
  const year = date.getFullYear()
  const month = date.getMonth() +1
  const day = date.getDate()
  const hours =  date.getHours()
  const minute = date.getMinutes()
  const second = date.getSeconds()
  function f(string) {
      return `0${string}`.slice(-2)
  }
  
  const map = {
      YYYY: year,
      YY: f(year),
      MM: f(month),
      M: month,
      DD: f(day),
      D: day,
      hh: f(hours),
      h: hours,
      mm: f(minute),
      m: minute,
      ss: f(second),
      s: second
  }

  return timeformat.replace(/YY{2,4}|M{1,2}|D{1,2}|h{1,2}|m{1,2}|s{1,2}/g,key => map[key])
  
}


//把部门数据处理成树组件可显示的格式
const orgListToTreeData = (orgList = []) => {
  return orgList.map(item => {
    return {
      title: item.name,
      value: item.id,
      key: item.id,
      children: item.children ? orgListToTreeData(item.children) : undefined
    };
  });
}

// 支持中英文大小写数字 web3.1.38 新加规则
const isChineseEnglishNum = inputValue => {
  let result = false;
  const reg = /^[0-9a-zA-Z\u4e00-\u9fa5]+$/

  if (!reg.test(inputValue)) {
    result = '输入格式不符合规范';
  }
  return result;
};


export {
  imageConfigToPaths,
  formatFilter,
  krCookie,
  krFileSize,
  krStrLen,
  krStrBytes,
  krStrCrop,
  krStrTrim,
  cleanObject,
  uploadImage,
  uploadImages,
  uploadFilesToOSS,
  getBrowserInfo,
  downloadImage,
  createBytedUploader,
  json2formdata,
  getDayTime,
  orgListToTreeData,
  newKrStrLen,
  formatDateTime,
  equalArray,
  isChineseEnglishNum,
  format
};
